import { LoadboardLabel, LoadboardValue, LoadboardDate, DropTrailerChip } from "@/components/dataPages/loadboard";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { FinishFlag } from "@/components/common/svgs/FinishFlag";
import { LocationText } from "@/components/common/text";
import { cn } from "@/utils/css";
dayjs.extend(customParseFormat);

export const LoadboardStop = ({ stop, first, last }) => {
    return (
        <div className="bg-cm-p-background rounded-lg px-3 pt-2 pb-3 flex flex-col relative">
            <LoadboardValue>
                <LocationText city={stop.stopCity} state={stop.stopState} />
            </LoadboardValue>
            <div
                className={cn("absolute left-[-15px] border-l-2 border-dashed border-cm-p-on-container-green", {
                    "top-[-4px] bottom-0": !first && !last,
                    "top-[18px] bottom-0": first,
                    "top-[-4px] bottom-[calc(100%-13px)]": last,
                })}
            />
            <div className="absolute left-[-19px] top-4">
                {!last ? <div className="w-[10px] h-[10px] rounded-full bg-cm-p-on-container-green" /> : <FinishFlag />}
            </div>
            <div>
                {stop.address1 ? <LoadboardLabel text={`${stop.address1}`} /> : null}{" "}
                {stop.address2 ? <LoadboardLabel text={`${stop.address2}`} /> : null}
                {(stop.address1 || stop.address2) && stop.postalCode ? `, ${stop.postalCode}` : null}
            </div>
            <div className="inline-flex flex-row items-center gap-[10px] text-cm-p-text-primary text-xs/[19px]">
                {stop.appointmentDate ? (
                    <span>
                        <LoadboardDate date={stop.appointmentDate} />
                    </span>
                ) : null}
                {stop.appointmentDate && (stop.earlyTime || stop.lateTime) ? (
                    <span className="size-[2px] rounded-full bg-cm-p-text-secondary shrink-0" />
                ) : null}
                {stop.earlyTime || stop.lateTime ? (
                    <span className="inline-flex flex-row items-center gap-[4px]">
                        {stop.earlyTime ? <span>{dayjs(stop.earlyTime, "HH:mm").format("h:mm A")}</span> : null}
                        {stop.earlyTime && stop.lateTime ? <span className="w-[4px] h-px bg-cm-p-text-secondary shrink-0" /> : null}
                        {stop.lateTime ? <span>{dayjs(stop.lateTime, "HH:mm").format("h:mm A")}</span> : null}
                    </span>
                ) : null}
            </div>
            {stop.loadingType === "DROP" ? <DropTrailerChip className="mt-2 self-start" /> : null}
            <div>
                {stop.appointmentInstructions ? <LoadboardLabel className="italic">{stop.appointmentInstructions}</LoadboardLabel> : null}
            </div>
        </div>
    );
};
